import PicUploader from './PicUploader.vue'

export default PicUploader